angular
  .module('cfn')
  .constant('EVENT_CHART_RESIZE', 'd-highcharts-wrapper_RESIZE')
  .directive('fnChartPie', chartPie);

chartPie.$inject = ['$timeout', '$window', 'EVENT_CHART_RESIZE', 'i18nFilter'];
function chartPie($timeout, $window, EVENT_CHART_RESIZE, i18nFilter) {
  var haAbbrLocalized = i18nFilter('enums.UnitsArealEnum.AREAL_HA');

  var baseChartConfig = {
    chart: {
      type: 'pie',
      animation: false,
      backgroundColor: 'rgba(255,255,255,0.002)',
      plotBorderWidth: null,
      plotShadow: true,
      spacing: [1, 1, 1, 1],
      stickyTracking: true,
      width: null
    },
    tooltip: {
      formatter: function() {
        return (
          '<b>' +
          this.point.fullName +
          '</b><br/>' +
          Math.floor(this.point.percentage) +
          '% (' +
          Math.round(this.point.y * 100) / 100 +
          ' ' +
          haAbbrLocalized +
          ')'
        );
      }
    },
    title: {
      text: null,
      align: 'left',
      verticalAlign: 'top',
      style: {
        fontSize: '12px'
      }
    },
    credits: {
      enabled: false
    },
    exporting: {
      enabled: false
    }
  };

  var chartConfigWithLegend = {
    plotOptions: {
      pie: {
        allowPointSelect: false,
        cursor: 'pointer',
        startAngle: 270,
        dataLabels: {
          enabled: false
        }
      }
    },
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'top',
      borderColor: '#fff',
      labelFormat:
        ' <b> {name}</b> {percentage:.0f}% ({y:.2f}' + haAbbrLocalized + ')'
    }
  };

  var chartConfigWithoutLegend = {
    plotOptions: {
      pie: {
        allowPointSelect: false,
        cursor: 'pointer',
        startAngle: 270,
        dataLabels: {
          enabled: true,
          format:
            '<b>{point.name}</b> {point.percentage:.1f} %<br/>{point.y:.2f} ' +
            haAbbrLocalized,
          style: {
            fontWeight: 'normal'
          }
        }
      }
    }
  };

  return {
    restrict: 'E',
    template: '<div ng-transclude></div>',
    replace: true,
    transclude: true,
    scope: {
      data: '<',
      height: '@',
      showLegend: '<',
      title: '@'
    },
    link: function link(scope, elem) {
      var chart = null; // chart instance

      scope.$watch('data', rerender, true);

      scope.$on(EVENT_CHART_RESIZE, reflow);

      function rerender() {
        if (chart) {
          // series array has always length of 1 because we created it exactly that way (see createChartConfig)
          _.first(chart.series).setData(scope.data);
          chart.redraw();
        } else {
          chart = $window.Highcharts.chart(elem[0], createChartConfig());
        }
      }

      function reflow() {
        $timeout(function() {
          if (
            chart &&
            $window.$(chart.renderToClone || chart.renderTo).width()
          ) {
            chart.reflow();
          }
        }, 0);
      }

      function createChartConfig() {
        var config = _.extend(angular.copy(baseChartConfig), {
          series: [
            {
              showInLegend: !!scope.showLegend,
              data: scope.data,
              animation: false
            }
          ]
        });

        if (scope.title) {
          config.title.text = i18nFilter(scope.title);
        }

        if (scope.height) {
          config.chart.height = scope.height;
        }

        _.extend(
          config,
          scope.showLegend
            ? angular.copy(chartConfigWithLegend)
            : angular.copy(chartConfigWithoutLegend)
        );

        return config;
      }
    }
  };
}
